import { makeStyles, Tooltip, Typography } from "@material-ui/core";
import React from "react";
import PropTypes from "prop-types";

import ExternalLink from "src/icons/ExternalLink";
import { getCurrentNetwork } from "src/web3/network";

const useStyles = makeStyles((theme) => ({
  viewOnBSCLink: {
    color: "inherit",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  tooltip: {
    maxWidth: "none",
  },
}));

function ViewAccountAddressOnBSC(props) {
  const { address, ...rest } = props;

  const classes = useStyles();
  const { blockExplorerUrls } = getCurrentNetwork();

  return (
    <Typography {...rest}>
      <Tooltip
        title={"View account on BSC Explorer"}
        placement="top"
        arrow
        interactive
        classes={{ tooltip: classes.tooltip }}
      >
        <a
          target="_blank"
          rel="noopener noreferrer"
          className={classes.viewOnBSCLink}
          href={`${blockExplorerUrls}/address/${address}`}
        >
          <ExternalLink size={14} />
        </a>
      </Tooltip>
    </Typography>
  );
}

export default ViewAccountAddressOnBSC;

ViewAccountAddressOnBSC.propTypes = {
  address: PropTypes.string.isRequired,
};

ViewAccountAddressOnBSC.defaultProps = {
  variant: "body2",
  gutterBottom: false,
};
